/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useContext, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { AccountContext } from "../Context";
import Overlay from "./Overlay";
import Login from "../pages/login/Login";
import LoginVerify from "../pages/login/LoginVerify";
import Dashboard from "../pages/dashboard/Dashboard";
import DataView from "../pages/data/DataView";

const Router = () => {
  // logged in
  const accountContext = useContext(AccountContext);
  const loggedIn = accountContext.loggedIn;

  // verify credentials
  const location = useLocation();
  const navigate = useNavigate();

  // immediately re-route to login page if not logged in
  useEffect(() => {
    const noAuthRoutes = ["/login", "/verify"];
    if (!loggedIn && !noAuthRoutes.some((route) => route === location.pathname)) {
      navigate("/login")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  return (
    <Routes>
      <Route path="/" element={<Overlay />}>
        <Route index element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify" element={<LoginVerify />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/data" element={<DataView />} />
      </Route>
    </Routes>
  );
};

export default Router;
